export default {
  inserted(el, bindling) {
    //bindling.value为指令的绑定值
      let perVal = bindling.value;
    if (bindling.value) {
    //这个权限信息(即pers)应该是不同用户登录时从后台拿到的对应的信息
          let pers=['monitor:user:add'];
          //hasPer为true为有权限
      //hasPer为false为无权限
        console.log(perVal);
        console.log(pers);
        let hasPer = pers.some(item => {
              return item == perVal
        });
        console.log(hasPer);
           //没有权限就先隐藏此元素吧
          if(!hasPer){
              el.style.display="none"
          }
      }
  }
}



// WEBPACK FOOTER //
// ./src/directives/permission.js